import React from 'react'
import { Link } from 'react-router-dom'
import './SignInLink.css'

export default function SignInLink() {
  return (
    <div className='signInLink'>
      <Link to='/login'>Sign In</Link>
    </div>
  )
}
